import React, { useEffect } from 'react';
import { clearIncidentsAction } from '../../../../redux/actions/incidents';
import { IIncident } from '../../interfaces';
import IncidentRow from '../IncidentRow';
import { IncidentDeleteModal } from '../../../../components/Incidents/IncidentModals';
import * as FormUI from '../../../pageForm/FormUI';
import { incidentHeaders } from '../../../pageForm/PageHeadersConfig';
import FormHeaders from '../../../pageForm/FormHeaders';
import { DictionaryTypeEnum } from '../../../../utils/interfaces';
import { formColumnsWidth } from '../../../pageForm/PageHeadersWidthConfig';
import { useAppDispatch, useAppSelector } from '../../../../redux/hooks';
import { selectOpenedModalType } from '../../../../redux/selectors/modal';
import { ModalSliceType, openModal } from '../../../../redux/slices/modal';
import UpdateIncidentModal from '../UpdateIncidentModal';

export default () => {
  const dispatch = useAppDispatch();

  const incidents: IIncident[] = useAppSelector(
    (state) => state.dictionary.calendarIncident,
  );
  const isDeleteModalOpen = useAppSelector((state) =>
    selectOpenedModalType(state, ModalSliceType.IncidentDelete, ''),
  );
  const isUpdateIncidentModalOpen = useAppSelector((state) =>
    selectOpenedModalType(state, ModalSliceType.EditCalendarIncident, ''),
  );

  const handleDeleteIncident = (incident: IIncident) => {
    dispatch(
      openModal({
        type: ModalSliceType.IncidentDelete,
        data: {
          incident,
        },
      }),
    );
  };

  useEffect(() => {
    return () => {
      dispatch(clearIncidentsAction());
    };
  }, [dispatch]);

  if (!incidents?.length) {
    return null;
  }

  return (
    <>
      <FormUI.Container>
        <FormUI.Row $isHeader $gridTemplateColumns={formColumnsWidth.incidents}>
          <FormHeaders
            dictionaryType={DictionaryTypeEnum.CalendarIncident}
            headerObject={incidentHeaders}
          />
        </FormUI.Row>
        {incidents.map((incident) => (
          <IncidentRow
            key={incident.id}
            incident={incident}
            onDeleteClick={() => handleDeleteIncident(incident)}
          />
        ))}
      </FormUI.Container>
      {isDeleteModalOpen && <IncidentDeleteModal />}
      {isUpdateIncidentModalOpen && <UpdateIncidentModal />}
    </>
  );
};
